interface Props {
  isPopular: boolean
  isSelected: boolean
  onSelect: () => void
  perDayLabel: string
  perDayPrice: string
  popularLabel: string
  saveLabel?: string
  subPrice: string
  title: string
}

export default function PricingPlanOption({
  isPopular,
  isSelected,
  onSelect,
  perDayLabel,
  perDayPrice,
  popularLabel,
  saveLabel,
  subPrice,
  title,
}: Props): React.ReactElement {
  // Scale the prominent per-day price down as it gets longer so it never overflows the card.
  const perDayPriceSize = perDayPrice.length > 11 ? 'text-6' : perDayPrice.length > 8 ? 'text-7' : 'text-6 md:text-9'

  return (
    <button
      className={`relative flex w-full items-center justify-between gap-2 rounded-4 border-2 px-4 py-4 text-left duration-300 md:px-6 md:py-5 ${
        isSelected ? 'border-purple-violet-600 bg-purple-yearly' : 'border-white/10 bg-purple-card'
      }`}
      onClick={onSelect}
      type="button"
    >
      {isPopular && (
        <span className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-purple-violet-600 px-4 py-1 text-2.75 font-bold uppercase text-white">
          {popularLabel}
        </span>
      )}
      <span className="flex min-w-0 shrink items-center gap-3 md:gap-4">
        <span
          className={`flex size-6 shrink-0 items-center justify-center rounded-full ${
            isSelected ? 'bg-purple-violet-600' : 'border-2 border-white/30'
          }`}
        >
          {isSelected && <span className="size-2 rounded-full bg-white" />}
        </span>
        <span className="flex min-w-0 flex-col gap-1">
          <span className="text-m-lg font-bold text-white">{title}</span>
          {saveLabel && <span className="text-3.25 font-bold text-amber-500">{saveLabel}</span>}
          <span className="text-xs text-purple-haze">{subPrice}</span>
        </span>
      </span>
      <span className="flex min-w-0 shrink flex-col items-end gap-0.5">
        <span className="flex flex-col items-end gap-0 md:flex-row md:items-baseline md:gap-1">
          <span className={`${perDayPriceSize} whitespace-nowrap font-black leading-none text-white`}>
            {perDayPrice}
          </span>
          <span className="whitespace-nowrap text-sm text-purple-haze">{perDayLabel}</span>
        </span>
      </span>
    </button>
  )
}
